import React from "react";
import { Link } from "react-router-dom";
import logo from '../../assets/logo.svg'


const Sidebar = () => {
    return (
        <div className="w-64 bg-gray-800 text-white p-6 flex flex-col">
            <h2 className="mb-6 mx-auto"><img src={logo} className="h-8" alt="Admin Panel" /></h2>
            <ul className="space-y-4">
                <li><Link to="/dashboard" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Dashboard</Link></li>
                <li><Link to="/user" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Users</Link></li>
                <li><Link to="/games" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Games</Link></li>
                <li><Link to="/game-plan" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Game Plan</Link></li>
                <li><Link to="/tasks" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Tasks</Link></li>
                {/* <li><Link to="/announcement" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Announcement</Link></li> */}
                {/* <li><Link to="/weekly-leaderboard" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Weekly Leaderboard</Link></li>
                <li><Link to="/pioneer-list" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Pioneer List</Link></li>*/}
                <li><Link to="/history" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">History</Link></li>
                <li><Link to="/notifications" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Notification</Link></li> 
                <li><Link to="/settings" className="py-3 px-4 bg-gray-900 rounded-lg cursor-pointer block hover:bg-gray-700 transition">Settings</Link></li>
            </ul>
        </div>
    );
};


export default Sidebar;